import { ideaDetailIns } from '@/services/detail-service';
import { computed, ref, onUnmounted, watch, onMounted } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useI18n } from 'vue-i18n';

export function useDetail() {
    const route = useRoute()
    const router = useRouter()
    const currId = computed(() => route.params.id)
    const { t } = useI18n();
    const show = ref(false)
    const detailBasicInfo = computed(() => ideaDetailIns.value.detailBasicInfo)
    const prevDisabled = computed(() => ideaDetailIns.value.isFirst)
    const nextDisabled = computed(() => ideaDetailIns.value.isLast)

    const totalList = computed(() => ideaDetailIns.value.totalList)
    const currentIndex = computed(() => ideaDetailIns.value.currentIndex + 1)

    const tabConfig = ref({
        currTab: 'summary',
        tabs: [
            { name: 'summary', label: t('summary') },
            { name: 'description', label: t('description') },
            { name: 'claim', label: t('claim') },
            { name: 'image', label: t('image') }
        ],
    });

    watch(
        () => currId.value,
        () => {
            if (currId.value) {
                ideaDetailIns.value.id = currId.value as string
            }
        },
        {
            immediate: true,
        }
    )

    onMounted(() => {
        show.value = true
    })

    onUnmounted(() => {
        ideaDetailIns.value.id = ''
    })

    function handleNext() {
        const nextId = ideaDetailIns.value.next()
        router.replace({
            path: `/detail/${nextId}/${tabConfig.value.currTab}`,
        })
    }

    function handlePrev() {
        const prevId = ideaDetailIns.value.prev()
        router.replace({
            path: `/detail/${prevId}/${tabConfig.value.currTab}`,
        })
    }

    function handleResult() {
        show.value = false
        setTimeout(() => {
            router.push({
                name: 'result',
                query: {
                    fromId: currId.value,
                },
            })
        }, 300);
    }

    function addIntoReport() {
        ideaDetailIns.value.addIntoReport()
    }

    function handelClickTab(name:string) {
        tabConfig.value.currTab = name
        router.replace({
            path: `/detail/${currId.value}/${name}`,
        })
    }

    return {
        show,
        totalList,
        currentIndex,
        tabConfig,
        currId,
        handleNext,
        handlePrev,
        handleResult,
        detailBasicInfo,
        prevDisabled,
        nextDisabled,
        addIntoReport,
        handelClickTab,
    }
}
